(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bm-neckline-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const openGuide = () => {
      const guide = document.getElementById('bm-neckline-guide');
      if (guide && new URLSearchParams(window.location.search).get('styling') === 'neckline') {
        const details = guide.querySelector('details');
        if (details) details.open = true;
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openGuide, { once: true });
    else openGuide();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bm-undertone-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-bm-undertone-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.delete('page');
    currentParams.set('sort_by', 'manual');
    destination.search = currentParams.toString();
    event.preventDefault();
    window.location.assign(destination.href);
  });
  (() => {
    const openGuide = () => {
      const guide = document.getElementById('bm-colour-guide');
      if (guide && new URLSearchParams(window.location.search).get('styling') === 'colour') {
        const details = guide.querySelector('details');
        if (details) details.open = true;
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openGuide, { once: true });
    else openGuide();
  })();
  } catch(e) { console.error(e); }
})();

})();
